if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        let config = "";

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Personalisation
        const personalisationActive = document.getElementById(
          "personalisation-yes"
        );
        const personalisationText = document.getElementById("personalisation");

        if (
          personalisationActive &&
          personalisationActive.checked &&
          personalisationText.value.length > 0
        ) {
          config = fetchConfig("json");
          let sections = "";
          if (this.cart) {
            sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id);
          }
          let productData = {
            items: [],
            sections: sections,
            sections_url: window.location.pathname,
          };
          let quantity = formData.get("quantity")
            ? parseInt(formData.get("quantity"))
            : 1;
          let personalisationValue = formData.get(
            "properties[Personalisation]"
          );
          let personalisationSize = formData.get(
            "properties[Personalisation Size]"
          );
          let personalisationColour = formData.get(
            "properties[Personalisation Colour]"
          );
          let preorder = formData.get("properties[Pre-Order Date]");

          const props = { _personalisation_product: true };

          if (personalisationValue) {
            props["Personalisation"] = personalisationValue;
          }

          if (personalisationSize) {
            props["_personalisation_size"] = personalisationSize;
          }

          if (personalisationColour) {
            props["_personalisation_colour"] = personalisationColour;
          }

          if (preorder) {
            props["Preorder"] = preorder;
          }

          if(personalisationValue || preorder) {
            const overrideData = {};
            
            if(personalisationValue) {
              overrideData.personalisation = personalisationValue;
            }
            
            if(preorder) {
              overrideData.preorder = preorder;
            }
            
            props["_product_name_override"] = JSON.stringify(overrideData);
          }

          productData.items.push({
            id: parseInt(formData.get("id")),
            quantity: quantity,
            properties: {
              ...props,
            },
          });
          config.body = JSON.stringify(productData);
        } else {
          config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            let cartAdd = true;
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response, cartAdd);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response, cartAdd);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });

        this.addToCartTracking();
      }

      addToCartTracking() {
        var dataLayerObject = {
          event: "add_to_cart",
          ecommerce: {
            items: [
              {
                item_id: this.submitButton.getAttribute("data-dl-id"),
                item_name: this.submitButton.getAttribute("data-dl-title"),
                currency: this.submitButton.getAttribute("data-dl-currency"),
                item_brand: this.submitButton.getAttribute("data-dl-brand"),
                price: this.submitButton.getAttribute("data-dl-price"),
                discount: this.submitButton.getAttribute("data-dl-discount"),
                quantity:
                  this.submitButton
                    .closest("form")
                    .querySelector('[name="quantity"]').value != null
                    ? this.submitButton
                        .closest("form")
                        .querySelector('[name="quantity"]').value
                    : 1,
                item_category:
                  this.submitButton.getAttribute("data-dl-category"),
                item_list_id: this.submitButton.getAttribute("data-dl-list-id"),
                item_list_name:
                  this.submitButton.getAttribute("data-dl-list-name"),
                item_variant: this.submitButton.getAttribute("data-dl-variant"),
              },
            ],
          },
        };
        updateDataLayer(dataLayerObject);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
